let main = document.querySelector(".template-index .main-content");
if(main){
  let container1 = document.createElement("div");
  container1.classList.add("featured-container");
  container1.classList.add("index-section");
  let featureds = document.querySelectorAll(".template-index .index-section--featured-collection");
  main.prepend(container1);
  let tabs = document.createElement("div");
  tabs.classList.add("featured-tabs");
  featureds.forEach(function(e, i){
    if(i > 0){
      e.classList.add("hide");
    }
    container1.append(e);
    let tab = document.createElement("h2");
    tab.classList.add("featured-tab");
    tab.classList.add("section-header__title");
    if(i == 0){
      tab.classList.add("featured-tab--active");
    }
    let title = e.querySelector(".section-header__title")
    tab.innerHTML = title.innerHTML.trim();
    title.classList.add("hide");
    title.parentNode.remove();
    tab.setAttribute("data-target", e.id);
    tab.addEventListener("click", function(e){
      document.querySelectorAll(".featured-container .index-section--featured-collection").forEach(function(e){
        e.classList.add("hide");
      })
      document.querySelector("#"+e.target.getAttribute("data-target")).classList.remove("hide");
      document.querySelectorAll(".featured-container .featured-tab").forEach(function(e){
        e.classList.remove("featured-tab--active");
      })
      e.target.classList.add("featured-tab--active");
      let tabs_container = document.querySelector(".featured-tabs-container");
      tabs_container.scrollLeft = (e.target.offsetLeft + e.target.offsetWidth/2) - tabs_container.clientWidth/2;
    })
    tabs.append(tab);
  });
  let tabs_container = document.createElement("div");
  tabs_container.classList.add("featured-tabs-container");
  tabs_container.append(tabs);
  container1.prepend(tabs_container);
  
  let container = document.createElement("div");
  container.classList.add("slider-container");
  let sliders = document.querySelectorAll(".template-index .index-section--hero");
  sliders[0].classList.add("slider-item");
  sliders[1].classList.add("slider-item");
  main.prepend(container);
  container.append(sliders[0], sliders[1]);
}
let item_titles = document.querySelectorAll(".collection-item__title");
if(item_titles.length > 0){
  item_titles[item_titles.length - 1].id = "read-more";
}
let item_prices = document.querySelectorAll(".grid-product__price");
if(item_prices.length > 0){
  item_prices[item_prices.length - 1].id = "read-more";
}
let floating_cart_btn = document.querySelector(".floating-cart-btn");
document.addEventListener("scroll", adm_scroll_handler);
function adm_scroll_handler(){
  if(floating_cart_btn){
    if(document.querySelectorAll("#dummy-chat-button-iframe").length){
      floating_cart_btn.classList.remove("hide");
      floating_cart_btn.style.left="28px";
      document.removeEventListener("scroll", adm_scroll_handler);
    }else if(document.querySelectorAll("#AppleBusinessChat").length){
      floating_cart_btn.classList.remove("hide");
      document.removeEventListener("scroll", adm_scroll_handler);
    }
  }else{
    document.removeEventListener("scroll", adm_scroll_handler);
  }
}

